<template>
  <div>
    <div class="list-page-header">
      <h3 class="title">{{ $t("graduated.page_title") }}</h3>
    </div>

    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :hideAction="!canAction('graduation')"
      :tableActionsComponent="TableActions"
      :bulkActions="tableBulkActions"
      :hideBulkAction="!canAction('graduation')"
      :sortable="sortable"
      mainField="full_name"
      selectable="multiple"
      ref="graduationStudentsTable"
      :formatTableData="formatTableData"
    >
    </yv-index>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import { Message, getId } from "../../helpers/utils";
import { GraduationStudents } from "@/constants/Permissions";
import { mapState } from "vuex";
import TableActions from "./TableActions";
import { DEFAULT_OPTION_ALL } from "@/constants";

export default {
  name: "ListPage",
  components: { YvIndex },
  data() {
    return {
      path: `${service_paths.students}/graduated`,
      formSearch: [
        {
          label: "graduated.select_programs",
          name: "program_id",
          value: "",
          type: "select",
          is_switch_locale: "false",
          options: [],
          width: 30
        },
        {
          label: "graduated.entered",
          name: "graduation",
          value: "",
          type: "date-picker",
          width: 30
        },
        {
          label: "common.status",
          name: "study_status",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            {
              id: "studying",
              name: "graduated.studying"
            },
            {
              id: "graduated",
              name: "graduated.graduated"
            }
          ],
          width: 30
        },
        {
          label: "common.student_code",
          name: "student_code__~",
          value: "",
          type: "input",
          width: 30
        },
        {
          label: "common.full_name",
          name: "full_name__~",
          value: "",
          type: "input",
          width: 30
        },
        {
          label: "common.username",
          name: "username__~",
          value: "",
          type: "input",
          width: 30
        }
      ],
      columns: {
        student_code: "common.student_code",
        username: "common.username",
        full_name: "common.full_name",
        grade: "common.grade",
        sex: "common.sex",
        email: "common.email",
        status: "common.status",
        actions: []
      },
      sortable: [
        "username",
        "student_code",
        "full_name",
        "email",
        "status",
        "grade"
      ],
      tableBulkActions: [
        {
          content: "graduated.graduation",
          action: () => {
            this.confirmGraduation();
          }
        }
      ],
      TableActions
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  methods: {
    getProgramList() {
      this.$axios
        .get(`${service_paths.programs}`, { limit: 99 })
        .then(({ data }) => {
          if (data) {
            this.formSearch[0].options = data.data;
            this.formSearch[0].value = data.data[0].id;
          }
        });
    },
    canAction(actionName) {
      return this.$can(
        GraduationStudents.actions[actionName],
        GraduationStudents.subject
      );
    },
    confirmGraduation() {
      let message = "";
      if (this.$refs.graduationStudentsTable.selectedItems.length > 1) {
        message = this.$t("graduated.message.multi_selected_graduation");
      } else {
        message = this.$t("graduated.message.selected_graduation");
      }
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: message,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-info btn-fill",
        cancelButtonClass: "md-button md-secondary btn-fill",
        confirmButtonText: this.$t("graduated.graduation"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.graduationSelectedStudent();
        }
      });
    },
    graduationSelectedStudent() {
      const student_ids = this.$refs.graduationStudentsTable.selectedItems.map(
        e => getId(e)
      );
      const program_id = this.formSearch[0].value;
      this.$axios
        .post(`${service_paths.students}/graduation/ids`, {
          student_ids,
          program_id
        })
        .then(() => {
          Message.success(this.$t("graduated.message.success"));
          // Reload table data
          this.$refs.graduationStudentsTable.getTableData();
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatTableData(tableData) {
      return tableData.map(classData => {
        const studyStatus = classData.study_status;
        if (studyStatus === "studying") {
          classData.status = `<span class="font-medium text-warning">${this.$t(
            "graduated.studying"
          )}</span>`;
        }
        if (studyStatus === "graduated") {
          classData.status = `<span class="font-medium text-success">${this.$t(
            "graduated.graduated"
          )}</span>`;
        }
        return classData;
      });
    }
  },
  created() {
    this.getProgramList();
  },
  provide() {
    return {
      confirmGraduation: this.confirmGraduation
    };
  }
};
</script>
